import { Theme, Typography, TypographyProps } from '@mui/material';
import React, { FC, KeyboardEvent } from 'react';

export const TypographyLink: FC<TypographyProps> = (props: TypographyProps) => {
  const { children, onClick, ...other } = props;

  const handleKeyDown = (event: KeyboardEvent<HTMLSpanElement>): void => {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }
    event.preventDefault();
    event.currentTarget.click();
  };

  return (
    <Typography
      {...other}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? handleKeyDown : undefined}
      variant={'inherit'}
      component={'span'}
      sx={{
        display: 'inline',
        cursor: 'pointer',
        color: (theme: Theme) => theme.colors.primary,
        ':hover': {
          color: (theme: Theme) => theme.colors.primaryDark,
        },
        ':focus-visible': {
          outline: (theme: Theme) => `2px solid ${theme.colors.primary}`,
          outlineOffset: '2px',
          borderRadius: '2px',
        },
      }}>
      {children}
    </Typography>
  );
};
